import { observer } from "mobx-react";
import React from "react";
import { Box, Divider, HStack, Stack, Text } from "@chakra-ui/react";
import { useStore } from "@/store";
import { OrderSummaryTableItem } from "./OrderSummaryTableItem";
import { translations } from "@/constants/translations";

export const OrderSummaryTable = observer(() => {
  const {
    activeLanguage,
    orderProducts,
    getShippingCostFormatted,
    orderData,
    orderTotals,
  } = useStore();
  const language = translations.pages["order-summary"][activeLanguage];

  return (
    <Stack spacing="8">
      <Stack spacing="8">
        {orderProducts.map((product) => (
          <OrderSummaryTableItem
            key={product.name}
            product={product}
            subtotalLabel={language.subtotal}
          />
        ))}
      </Stack>
      <Stack spacing="8">
        <HStack>
          <Box width={{ base: "0", md: "320px" }} />
          <Stack
            spacing="4"
            flex="1"
            alignItems="flex-end"
          >
            <Divider />
            {orderTotals.discount > 0 && (
              <>
                {orderProducts.length > 1 && (
                  <HStack>
                    <Text
                      minWidth="120px"
                      textAlign="right"
                    >
                      Order subtotal:
                    </Text>
                    <Text fontWeight="bold">
                      {orderTotals.formatted.subtotal}
                    </Text>
                  </HStack>
                )}

                <HStack>
                  <Text
                    minWidth="120px"
                    textAlign="right"
                  >
                    Discount:
                  </Text>
                  <Text fontWeight="bold">
                    {orderTotals.formatted.discount}
                  </Text>
                </HStack>
                <Divider />
              </>
            )}

            <HStack>
              <Text>{language.shipping}</Text>
              <Text fontWeight="bold">{getShippingCostFormatted()}</Text>
            </HStack>
            {orderData.tax > 0 && (
              <HStack>
                <Text>{language.tax}</Text>
                <Text fontWeight="bold">{orderTotals.formatted.tax}</Text>
              </HStack>
            )}
            <HStack color="primary-light">
              <Text fontWeight="bold">{language.total}</Text>
              <Text fontWeight="bold">{orderTotals.formatted.total}</Text>
            </HStack>
          </Stack>
        </HStack>
      </Stack>
    </Stack>
  );
});
